import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../stores/rootReducer";

import { useDrawsStyles } from "../Draws.styles";
import { DrawRequestStore } from "../../../stores/drawRequest/drawRequest.interface";
import {
  formatAuditTrailTimestamp,
  getAuditTrailDisplayName,
  getInitials
} from "../../AssetManagement.utils";
import { servicerStageHistoryInterface } from "../../../stores/servicerOnboarding/servicerOnboarding.interface";

export const StageAuditTrail = ({
  onboardingStatusHistory
}: {
  onboardingStatusHistory?: any[];
}) => {
  const classes = useDrawsStyles();
  const { drawStageHistory } = useSelector<RootState, DrawRequestStore>(
    (state) => state.drawRequestStore
  );
  const genericHistoryData: any[] = onboardingStatusHistory || drawStageHistory;

  return (
    <div
      data-testid="stage-audit-trail"
      style={{
        position: "absolute",
        left: 0,
        top: "100%",
        paddingTop: 6,
        right: "auto",
        zIndex: 999
      }}
    >
      <div className={classes.auditTrailParentDiv}>
        {genericHistoryData?.length > 0 ? (
          <div className={classes.auditTrailList}>
            {genericHistoryData.map(
              (row: servicerStageHistoryInterface, idx: number) => {
                const isLast = idx === genericHistoryData.length - 1;
                const displayName = getAuditTrailDisplayName(
                  row.updatedBy,
                  row.stageName || row.status
                );
                const timestamp = formatAuditTrailTimestamp(row.updatedTimeStamp);

                return (
                  <div
                    className={classes.auditTrailEntry}
                    key={`${row.updatedTimeStamp}_${idx}`}
                  >
                    <div className={classes.auditTrailRail}>
                      <span className={classes.bullet} />
                      {!isLast && (
                        <span className={classes.auditTrailRailLine} />
                      )}
                    </div>
                    <div className={classes.auditTrailContent}>
                      <div className={classes.auditTrailStage}>
                        {row.stageName || row.status}
                      </div>
                      {row.comment ? (
                        <div className={classes.auditCommentBlock}>
                          <span className={classes.auditTrailComment}>
                            Comment:
                          </span>{" "}
                          {row.comment}
                        </div>
                      ) : null}
                      <div className={classes.origDetails}>
                        <div className={classes.auditTrailavatar}>
                          {getInitials(
                            displayName === "Unknown" ? "" : displayName
                          )}
                        </div>
                        <div className={classes.auditTrailUserMeta}>
                          <span className={classes.personName}>
                            {displayName}
                          </span>
                          {timestamp ? (
                            <div className={classes.auditTrailTimestamp}>
                              <span>{timestamp.dateLine}</span>
                              <span>{timestamp.timeLine}</span>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
            )}
          </div>
        ) : (
          <div className={`${classes.auditCommentBlock} ${classes.noAuditData}`}>
            No Data Available
          </div>
        )}
      </div>
    </div>
  );
};
